import { Link, usePage } from '@inertiajs/react';
import { BrandIcon, buildBrandLink, getBrandButtonStyle } from '@/Components/Frontend/BrandIcons';

export default function Footer() {
    const { settings } = usePage().props;
    const supportLinks = [
        { key: 'telegram', label: 'Telegram', type: 'telegram', value: settings?.telegram },
        { key: 'signal', label: 'Signal', type: 'signal', value: settings?.signal },
        { key: 'whatsapp', label: 'WhatsApp', type: 'whatsapp', value: settings?.whatsapp },
    ]
        .map((item) => ({
            ...item,
            href: buildBrandLink(item.type, item.value),
        }))
        .filter((item) => item.href);

    const copyrightText = settings?.copyright_text?.trim()
        || `Copyright ${new Date().getFullYear()} ${settings?.name || 'Havis.ai'}. All rights reserved.`;

    return (
        <footer className="border-t border-slate-200 dark:border-white/10 min-h-[56px] flex items-center px-6 py-3 bg-white dark:bg-background-dark text-slate-600 dark:text-white/60 transition-colors duration-300">
            <div className="max-w-[1200px] w-full mx-auto flex flex-wrap justify-between items-center gap-4">
                <div className="text-xs font-medium">
                    {copyrightText}
                </div>
                <div className="hidden md:flex items-center gap-6">
                    <div className="flex items-center gap-5">
                        <Link className="hover:text-primary transition-all text-xs uppercase tracking-widest font-bold hover:scale-110" href="/privacy">Privacy</Link>
                        <Link className="hover:text-primary transition-all text-xs uppercase tracking-widest font-bold hover:scale-110" href="/terms">Terms</Link>
                    </div>
                    {supportLinks.length > 0 && (
                        <div className="flex items-center gap-2.5 pl-5 border-l border-slate-200 dark:border-white/10">
                            <span className="text-[11px] uppercase tracking-[0.18em] font-bold text-slate-400 dark:text-white/35">
                                Support
                            </span>
                            {supportLinks.map((item) => {
                                const style = getBrandButtonStyle(item.type);

                                return (
                                    <a
                                        key={item.key}
                                        href={item.href}
                                        target="_blank"
                                        rel="noreferrer"
                                        title={item.label}
                                        aria-label={item.label}
                                        className="inline-flex size-8 items-center justify-center rounded-full shadow-sm transition-transform duration-200 hover:-translate-y-0.5"
                                        style={style}
                                    >
                                        <BrandIcon type={item.type} className="size-[15px]" />
                                    </a>
                                );
                            })}
                        </div>
                    )}
                </div>
            </div>
        </footer>
    );
}
